<template>
  <div 
    @click="calculate_progress" 
    @keydown="progressbar.userKeyDown()" 
    @keyup="progressbar.userKeyUp()"
  >
    <h3 
      class="
                mx-5 mt-5 mb-15
                md:mx-15 md:mt-15
                2xl:mx-20 2xl:mt-20 2xl:mb-20
            "
    >
      Parcours
    </h3>
    <!-- BEGIN Situation professionnelle -->

    <!-- BEGIN Button to add a "Parcours" -->
    <div 
      v-if="$can(infosPage.name_page+'_edit', infosPass.id_pass)"
      class="w-max-content w-max cursor-pointer text-gray-900 hover:text-gray-600 relative mx-5 md:mx-15 2xl:mx-20"
    >
      <add-button
        id="add-parcours"
        libelle="Ajouter un parcours"
        @add="displayDropdownMenu"
        :with-dropdown="true"
      /> 

      <!-- BEGIN Menu dropdown type de parcours -->
      <transition
        enter-active-class="ease-out duration-150"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          v-if="dropDownMenu"
          v-click-outside="forceHide"
          class="z-20 absolute left-20
                        mt-1 w-max-content w-max ml-auto
                        rounded-md bg-white shadow-md shadow-gray-600
                        text-sm font-normal"
        >
          <div class="mx-5 my-3 text-left ">
            <div
              v-for="(type, index) in typeParcours"
              :key="index"
              class="cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900"
              @click="addItem('parcours', type)"
            >
              {{ type }}
            </div>
          </div>
        </div>
      </transition>
      <!-- END Menu dropdown type de parcours -->
    </div>
    <!-- END Button to add a "Parcours" -->

    <!-- BEGIN list of parcours -->
    <div v-if="form.parcours.length > 0 || this.otherParcours.length > 0">
      <list-grid
        :list-items="sortedParcours"
        grid="grid-cols-11 md:grid-cols-12"
        :is-accordion-items="true"
        @displayNum="(num) => {parcoursDisplayed = num}"
        ref="listParcours"
      >
        <template #header>
          <div class="col-start-2 col-span-5 md:col-start-2 md:col-span-3">
            Période
          </div>
          <div class="hidden md:block md:col-span-4">
            Type de parcours
          </div>
          <div class="col-span-5 md:col-span-4">
            Intitulé
          </div>
        </template> 

        <template #accordionDescription="{item, num}">
          <icon
            :class="{'rotate-90': parcoursDisplayed === num}"
            class="text-pink-600 col-span-1 justify-self-end md:justify-self-center 
                                transform transition-transform ease-in-out duration-300"
            name="chevron-right"
          />
          <div class="col-span-5 md:col-span-3 text-sm md:text-base flex items-center space-x-1 md:space-x-2">
            <span
              v-if="item.projet"
              class=""
            >
              <info-bulle
                libelle="Ce parcours est ajouté depuis la partie projet du plan d'accompagnement. Pour toutes modifications ou suppressions passer par l'onglet Projet"
                hoverable
                :name="item.projet + num"
              />
            </span>
            <!-- Période -->
            <span v-if="item.value.debut_parcours">
              {{ ('0' + new Date(item.value.debut_parcours).getDate()).slice(-2) }}/{{ ('0' + (new Date(item.value.debut_parcours).getMonth() + 1)).slice(-2) }}/{{ new Date(item.value.debut_parcours).getFullYear() }}
            </span>
            <span>-</span>
            <span v-if="item.value.debut_parcours && !(item.value.fin_parcours)">En cours</span>
            <span v-if="item.value.fin_parcours">
              {{ ('0' + new Date(item.value.fin_parcours).getDate()).slice(-2) }}/{{ ('0' + (new Date(item.value.fin_parcours).getMonth() + 1)).slice(-2) }}/{{ new Date(item.value.fin_parcours).getFullYear() }}
            </span>
          </div>
          <div class="md:col-span-4 hidden md:block">
            <!-- Type de parcours -->
            <tag 
              :libelle="item.type"
              :theme-color="typeTheme(item.type)"
            />
          </div>
          <div class="col-span-5 md:col-span-4 text-sm italic line-clamp-2 mr-5">
            <!-- Intitulé -->
            {{ item.value.intitule_parcours }}
          </div>
        </template>

        <template #accordionContent="{item, num}">
          <!-- BEGIN Form Formation initiale -->
          <div
            v-show="parcoursDisplayed === num"
            :key="'formation_initiale'+num"
          >
            <div
              v-if="item.type === 'Formation initiale'"
              class="grid grid-cols-12 gap-x-4 gap-y-10"
            >
              <input-text
                :error="true"
                :maxlength="50"
                :necessary="true"
                :value="item.value.intitule_parcours"
                class="md:col-span-6"
                libelle="Diplôme et titre obtenu"
                name="intitule_parcours"
                @input="(newValue) => {item.value.intitule_parcours = newValue}"
              />

              <date-picker
                :necessary-date="true"
                :value="item.value.debut_parcours"
                class="col-span-full md:col-span-2"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Début"
                name="debut_parcours"
                @input="(newValue) => {if (item.value.fin_parcours === '' || $verifyDates({debut: newValue, fin: item.value.fin_parcours})){item.value.debut_parcours = newValue} else {badDates()} sortParcours();}"
              />

              <date-picker
                :necessary-date="true"
                :value="item.value.fin_parcours"
                class="col-span-full md:col-span-2"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Fin"
                name="fin_parcours"
                @input="(newValue) => {if (item.value.debut_parcours === '' || $verifyDates({debut: item.value.debut_parcours, fin: newValue})){item.value.fin_parcours = newValue} else {badDates()}}"
              />

              <input-text
                :necessary="true"
                :value="item.value.localisation_parcours"
                class="md:col-span-2"
                libelle="Ville"
                name="localisation_parcours"
                @input="(newValue) => {item.value.localisation_parcours = newValue}"
              />

              <input-select
                :datas="[
                  {value: 'Aucun'},
                  {value: 'Niveau 3 - CAP, BEP'},
                  {value: 'Niveau 4 - Baccalauréat'},
                  {value: 'Niveau 5 - DEUG, BTS, DUT, DEUST'},
                  {value: 'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1'},
                  {value: 'Niveau 7 - Master, diplôme d\'études approfondies, diplôme d\'études supérieures spécialisées, diplôme d\'ingénieur'},
                  {value: 'Niveau 8 - Doctorat, habilitation à diriger des recherches'},
                  {value: 'Autre'},
                ]"
                :necessary="true"
                :value="item.value.niveau_cursus"
                class="md:col-span-6"
                libelle="Niveau de formation"
                name="niveau_cursus"
                @input="(newValue) => {item.value.niveau_cursus = newValue}"
              />

              <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
              >
                <input-text
                  v-if="item.value.niveau_cursus === 'Autres'"
                  :necessary="true"
                  :value="item.value.niveau_cursus_precis"
                  class="md:col-span-3"
                  libelle="Autre niveau"
                  name="niveau_cursus_precis"
                  @input="(newValue) => {item.value.niveau_cursus_precis = newValue}"
                />
              </transition>

              <input-select
                :datas="[
                  {value: 'Jamais scolarisé(e)'},
                  {value: 'Scolarisé(e) en Etablissement Médico Social (IME-IMPRO, ITEP...)'},
                  {value: 'Collège (Classe ordinaire)'},
                  {value: 'Collège UPI'},
                  {value: 'Lycée (Classe ordinaire)'},
                  {value: 'Lycée UPI'},
                  {value: 'Enseignement technique ou professionnel court (CAP, BEP etc...)'},
                  {value: 'Enseignement technique ou professionnel long (Brevet pro, Bac pro etc...)'},
                  {value: 'Universités ou études supérieures'},
                  {value: 'Non précisé'},
                ]"
                :necessary="true"
                :value="item.value.etablissement_cursus"
                class="md:col-span-6"
                libelle="Type d'établissement"
                name="etablissement_cursus"
                @input="(newValue) => {item.value.etablissement_cursus = newValue}"
              />

              <h4 class="col-span-full text-gray-600 my-5 lg:my-10">
                Les compétences acquises pendant votre formation
              </h4>

              <!-- DEBUT Pratiques professionnelles -->
              <div class="col-span-full md:col-span-4">
                <div class="block ">
                  <label class="text-base text-gray-900">Pratiques professionnelles</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche."
                      name="pratiques_formation"
                    >
                      <template #libelleBefore>
                        être capable de...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(pratique, i) in item.value.pratiques"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.pratiques, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="pratique.value"
                    class="px-4"
                    libelle=""
                    name="pratiques"
                    @input="(newValue) => {pratique.value = newValue}"
                  />
                </div>

                <add-button
                  class="mt-5"
                  libelle="Ajouter une pratique"
                  @add="addItem('competences', item.value.pratiques)"
                />
              </div>
              <!-- FIN Pratiques professionnelles -->

              <!-- DEBUT Connaissances associées -->
              <div class="col-span-full md:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">Connaissances associées</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience."
                      name="connaissances_formation"
                    >
                      <template #libelleBefore>
                        Théoriques, procédurales...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(connaissance, i) in item.value.connaissances"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.connaissances, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="connaissance.value"
                    class="px-4"
                    libelle=""
                    name="connaissances"
                    @input="(newValue) => {connaissance.value = newValue}"
                  />
                </div>
                <add-button
                  class="mt-5"
                  libelle="Ajouter une connaissance"
                  @add="addItem('competences', item.value.connaissances)"
                />
              </div>
              <!-- FIN Connaissances associées -->

              <!-- DEBUT Comportements / aptitudes -->
              <div class="col-span-full md:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">
                    <info-bulle
                      :size-less="true"
                      libelle="Capacité de produire des actions et des réactions adaptées à l’environnement humain."
                      name="comportements_formation"
                    >
                      <template #libelleBefore>
                        Comportements / aptitudes
                      </template>
                    </info-bulle>
                  </label>
                  <em class="block text-sm text-gray-600"><br></em> <!-- To align with others -->
                </div>

                <div
                  v-for="(comportement, i) in item.value.comportements"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.comportements, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="comportement.value"
                    class="px-4"
                    libelle=""
                    name="comportements"
                    @input="(newValue) => {comportement.value = newValue}"
                  />
                </div>
                <add-button
                  class="mt-8"
                  libelle="Ajouter une aptitude"
                  @add="addItem('competences', item.value.comportements)"
                />
              </div>
              <!-- FIN Comportements / aptitudes -->

              <delete-button 
                class="col-span-full"
                libelle="Supprimer ce parcours"
                @del="deleteItem(form.parcours, num)"
              />
            </div>
          </div>

          <!-- END Form Formation initiale -->

          <!-- BEGIN Form Parcours professionnel -->
          <div
            v-show="parcoursDisplayed === num"
            :key="'parcours_professionnel'+num"
          >
            <div
              v-if="item.type === 'Parcours professionnel'"
              class="bg-white grid grid-cols-12 gap-x-4 gap-y-10"
            >
              <date-picker
                :necessary-date="true"
                :value="item.value.debut_parcours"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Début"
                name="debut_parcours"
                @input="(newValue) => {if (item.value.fin_parcours === '' || $verifyDates({debut: newValue, fin: item.value.fin_parcours})){item.value.debut_parcours = newValue} else {badDates()} sortParcours();}"
              />

              <date-picker
                :necessary-date="true"
                :value="item.value.fin_parcours"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Fin"
                name="fin_parcours"
                @input="(newValue) => {if (item.value.debut_parcours === '' || $verifyDates({debut: item.value.debut_parcours, fin: newValue})){item.value.fin_parcours = newValue} else {badDates()}}"
              />

              <input-text
                :necessary="true"
                :value="item.value.structure_accueil_parcours"
                class="col-start-1 md:col-span-3"
                libelle="Nom de la structure d'accueil"
                name="structure_accueil_parcours"
                @input="(newValue) => {item.value.structure_accueil_parcours = newValue}"
              />

              <input-text
                :necessary="true"
                :value="item.value.localisation_parcours"
                class="md:col-span-3"
                libelle="Localisation"
                name="localisation_parcours"
                @input="(newValue) => {item.value.localisation_parcours = newValue}"
              />

              <input-text
                :error="true"
                :maxlength="50"
                :necessary="true"
                :value="item.value.intitule_parcours"
                class="col-start-1 md:col-span-3"
                libelle="Poste occupé"
                name="intitule_parcours"
                @input="(newValue) => {item.value.intitule_parcours = newValue}"
              />

              <input-select
                :datas="[
                  {value: 'Contrat de soutien et d\'aide par le travail'},
                  {value: 'Contrat de travail à durée indéterminée'},
                  {value: 'Contrat de travail à durée déterminée'},
                  {value: 'Contrat d\'apprentissage'},
                  {value: 'Contrat de prestation de service'},
                  {value: 'Contrat de professionnalisation'},
                  {value: 'Contrat de travail intérimaire'},
                  {value: 'Contrat unique d\'insertion - Secteur privé'},
                  {value: 'Contrat unique d\'insertion - Secteur public'},
                  {value: 'Contrat saisonnier'},
                  {value: 'Contrat de mise à disposition'},
                  {value: 'Autres contrats'},
                ]"
                :necessary="true"
                :value="item.value.type_contrat_pro"
                class="md:col-span-3"
                libelle="Type de contrat"
                name="type_contrat_pro"
                @input="(newValue) => {item.value.type_contrat_pro = newValue}"
              />

              <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
              >
                <input-text
                  v-if="item.value.type_contrat_pro === 'Autres contrats'"
                  :necessary="true"
                  :value="item.value.type_contrat_pro_precis"
                  class="md:col-span-3"
                  libelle="Autre type de contrat"
                  name="type_contrat_pro_precis"
                  @input="(newValue) => {item.value.type_contrat_pro_precis = newValue}"
                />
              </transition>

              <input-select
                :datas="[
                  {value: 'Temps plein'},
                  {value: 'Temps partiel'},
                ]"
                :necessary="true"
                :value="item.value.temps_pro"
                class="md:col-span-3"
                libelle="Temps plein/partiel"
                name="temps_pro"
                @input="(newValue) => {item.value.temps_pro = newValue}"
              />

              <input-text
                :necessary="true"
                :value="item.value.temps_travail_pro"
                class="md:col-span-3"
                libelle="Temps de travail hebdo (en h)"
                name="temps_travail_pro"
                @input="(newValue) => {item.value.temps_travail_pro = newValue}"
              />

              <input-text-area
                :necessary="true"
                :value="item.value.aborde_parcours"
                class="lg:col-start-1 md:col-span-6"
                libelle="Les activités et tâches principales qui vous ont été confiées"
                name="aborde_parcours"
                @input="(newValue) => {item.value.aborde_parcours = newValue}"
              />
              <input-text-area
                :value="item.value.commentaires_parcours"
                class="md:col-span-6"
                libelle="Commentaires"
                name="commentaires_parcours"
                @input="(newValue) => {item.value.commentaires_parcours = newValue}"
              />

              <h4 class="col-span-full text-gray-600 my-10">
                Les compétences mobilisées pour mener à bien vos activités ou tâches professionnelles
              </h4>

              <!-- DEBUT Pratiques professionnelles -->
              <div class="col-span-full md:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">Pratiques
                    professionnelles</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche."
                      name="pratiques_pro"
                    >
                      <template #libelleBefore>
                        être capable de...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(pratique, i) in item.value.pratiques"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.pratiques, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="pratique.value"
                    class="px-4"
                    libelle=""
                    name="pratiques"
                    @input="(newValue) => {pratique.value = newValue}"
                  />
                </div>

                <add-button
                  class="mt-5"
                  libelle="Ajouter une pratique"
                  @add="addItem('competences', item.value.pratiques)"
                />
              </div>
              <!-- FIN Pratiques professionnelles -->

              <!-- DEBUT Connaissances associées -->
              <div class="col-span-full md:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">Connaissances associées</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience."
                      name="connaissances_pro"
                    >
                      <template #libelleBefore>
                        Théoriques, procédurales...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(connaissance, i) in item.value.connaissances"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.connaissances, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="connaissance.value"
                    class="px-4"
                    libelle=""
                    name="connaissances"
                    @input="(newValue) => {connaissance.value = newValue}"
                  />
                </div>
                <add-button
                  class="mt-5"
                  libelle="Ajouter une connaissance"
                  @add="addItem('competences', item.value.connaissances)"
                />
              </div>
              <!-- FIN Connaissances associées -->

              <!-- DEBUT Comportements / aptitudes -->
              <div class="col-span-full md:col-span-4">
                <div class="block ">
                  <label class="text-base text-gray-900 font-medium">
                    <info-bulle
                      :size-less="true"
                      libelle="Capacité de produire des actions et des réactions adaptées à l’environnement humain."
                      name="comportements_pro"
                    >
                      <template #libelleBefore>
                        Comportements / aptitudes
                      </template>
                    </info-bulle>
                  </label>
                  <em class="block text-sm text-gray-600"><br></em> <!-- To align with others -->
                </div>

                <div
                  v-for="(comportement, i) in item.value.comportements"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.comportements, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="comportement.value"
                    class="px-4"
                    libelle=""
                    name="comportements"
                    @input="(newValue) => {comportement.value = newValue}"
                  />
                </div>

                <add-button
                  class="mt-5"
                  libelle="Ajouter une aptitude"
                  @add="addItem('competences', item.value.comportements)"
                />
              </div>
              <!-- FIN Comportements / aptitudes -->

              <delete-button 
                class="col-span-full"
                libelle="Supprimer ce parcours"
                @del="deleteItem(form.parcours, num)"
              />
            </div>
          </div>
          <!-- END Form Parcours professionnel -->

          <!-- BEGIN Form Formation professionnelle continue -->
          <div
            v-show="parcoursDisplayed === num"
            :key="'formation_professionnelle_continue'+num"
          >
            <div
              v-if="item.type === 'Formation professionnelle continue'"
              class="bg-white grid grid-cols-12 gap-x-4 gap-y-10"
            >
              <date-picker
                :necessary-date="true"
                :value="item.value.debut_parcours"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Début"
                name="debut_parcours"
                @input="(newValue) => {if (item.value.fin_parcours === '' || $verifyDates({debut: newValue, fin: item.value.fin_parcours})){item.value.debut_parcours = newValue} else {badDates()} sortParcours();}"
              />

              <date-picker
                :necessary-date="true"
                :value="item.value.fin_parcours"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Fin"
                name="fin_parcours"
                @input="(newValue) => {if (item.value.debut_parcours === '' || $verifyDates({debut: item.value.debut_parcours, fin: newValue})){item.value.fin_parcours = newValue} else {badDates()}}"
              />

              <input-text
                :necessary="true"
                :value="item.value.duree_formation"
                class="md:col-span-3"
                libelle="Durée (en h)"
                name="duree_formation"
                @input="(newValue) => {item.value.duree_formation = newValue}"
              />

              <input-text
                :error="true"
                :maxlength="50"
                :necessary="true"
                :value="item.value.intitule_parcours"
                class="col-start-1 md:col-span-6"
                libelle="Intitulé de la formation"
                name="intitule_parcours"
                @input="(newValue) => {item.value.intitule_parcours = newValue}"
              />

              <input-text
                :necessary="true"
                :value="item.value.organisme_formation_pro"
                class="md:col-span-3"
                libelle="Organisme de formation"
                name="organisme_formation_pro"
                @input="(newValue) => {item.value.organisme_formation_pro = newValue}"
              />

              <input-text
                :necessary="true"
                :value="item.value.localisation_parcours"
                class="md:col-span-3"
                libelle="Localisation"
                name="localisation_parcours"
                @input="(newValue) => {item.value.localisation_parcours = newValue}"
              />

              <input-select
                :datas="[
                  {value: 'Interne'},
                  {value: 'Externe'},
                ]"
                :necessary="true"
                :value="item.value.type_formation_pro"
                class="md:col-span-3"
                libelle="Type de formation"
                name="type_formation_pro"
                @input="(newValue) => {item.value.type_formation_pro = newValue}"
              />

              <input-select
                :datas="[
                  {value: 'Oui'},
                  {value: 'Non'},
                ]"
                :necessary="true"
                :value="item.value.attestation_formation_pro"
                class="md:col-span-3"
                libelle="Attestation de formation"
                name="attestation_formation_pro"
                @input="(newValue) => {item.value.attestation_formation_pro = newValue}"
              />

              <input-select
                :datas="[
                  {value: 'Aucune'},
                  {value: 'Niveau 3 - CAP, BEP'},
                  {value: 'Niveau 4 - Baccalauréat'},
                  {value: 'Niveau 5 - DEUG, BTS, DUT, DEUST'},
                  {value: 'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1'},
                  {value: 'Niveau 7 - Master, diplôme d\'études approfondies, diplôme d\'études supérieures spécialisées, diplôme d\'ingénieur'},
                  {value: 'Niveau 8 - Doctorat, habilitation à diriger des recherches'},
                  {value: 'CQP (CQPI)'},
                  {value: 'CQPM'},
                  {value: 'Reconnaissance CCN'},
                  {value: 'Reconnaissance CPNAA/CPNE'},
                  {value: 'Certification Professionnelle'},
                  {value: 'Diplômes Européens'},
                  {value: 'CCP'},
                  {value: 'CCF'},
                  {value: 'RSFP'},
                  {value: 'Attestation de compétences'},
                  {value: 'Attestation de Formation'},
                  {value: 'Autres'},
                ]"
                :necessary="true"
                :value="item.value.certifications_obtenues_formation_pro"
                class="md:col-span-3"
                libelle="Certifications obtenues"
                name="certifications_obtenues_formation_pro"
                @input="(newValue) => {item.value.certifications_obtenues_formation_pro = newValue}"
              />

              <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
              >
                <input-text
                  v-if="item.value.certifications_obtenues_formation_pro === 'Autres'"
                  :necessary="true"
                  :value="item.value.autres_certifications_formation_pro"
                  class="md:col-span-3"
                  libelle="Autres certifications"
                  name="autres_certifications_formation_pro"
                  @input="(newValue) => {item.value.autres_certifications_formation_pro = newValue}"
                />
              </transition>

              <input-select
                :datas="[
                  {value: 'Formation de Professionnalisation'},
                  {value: 'Formation d\'Intégration'},
                  {value: 'Formation de perfectionnement'},
                  {value: 'Formation de préparation aux concours et examens professionnels'},
                  {value: 'Formation personnelle'},
                  {value: 'Autre'},
                ]"
                :necessary="true"
                :value="item.value.raisons_formation_pro"
                class="md:col-span-3"
                libelle="Formation suivie au titre de"
                name="raisons_formation_pro"
                :left="true"
                @input="(newValue) => {item.value.raisons_formation_pro = newValue}"
              />

              <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
              >
                <input-text
                  v-if="item.value.raisons_formation_pro === 'Autre'"
                  :necessary="true"
                  :value="item.value.raisons_formation_pro_precis"
                  class="md:col-span-3"
                  libelle="Autre raisons"
                  name="raisons_formation_pro_precis"
                  @input="(newValue) => {item.value.raisons_formation_pro_precis = newValue}"
                />
              </transition>

              <input-select
                :datas="[
                  {value: 'En cours'},
                  {value: 'Menée à son terme'},
                  {value: 'Interrompue'},
                ]"
                :necessary="true"
                :value="item.value.precision_formation_pro"
                class="md:col-span-3"
                libelle="Précision"
                name="precision_formation_pro"
                @input="(newValue) => {item.value.precision_formation_pro = newValue}"
              />

              <input-text-area
                :necessary="true"
                :value="item.value.aborde_formation"
                class="lg:col-start-1 md:col-span-6"
                libelle="Ce que j'ai appris (connaissances acquises ou abordées)"
                name="aborde_formation"
                @input="(newValue) => {item.value.aborde_formation = newValue}"
              />
              <input-text-area
                :value="item.value.commentaires_parcours"
                class="md:col-span-6"
                libelle="Commentaires"
                name="commentaires_parcours"
                @input="(newValue) => {item.value.commentaires_parcours = newValue}"
              />

              <h4 class="col-span-full text-gray-600 my-10">
                Les compétences acquises pendant votre formation
              </h4>

              <!-- DEBUT Pratiques professionnelles -->
              <div class="col-span-full md:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">Pratiques
                    professionnelles</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche."
                      name="pratiques_formation_pro"
                    >
                      <template #libelleBefore>
                        être capable de...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(pratique, i) in item.value.pratiques"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.pratiques, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="pratique.value"
                    class="px-4"
                    libelle=""
                    name="pratiques"
                    @input="(newValue) => {pratique.value = newValue}"
                  />
                </div>

                <add-button
                  class="mt-5"
                  libelle="Ajouter une pratique"
                  @add="addItem('competences', item.value.pratiques)"
                />
              </div>
              <!-- FIN Pratiques professionnelles -->

              <!-- DEBUT Connaissances associées -->
              <div class="col-span-full md:col-span-4">
                <div class="block ">
                  <label class="text-base text-gray-900 font-medium">Connaissances associées</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience."
                      name="connaissances_formation_pro"
                    >
                      <template #libelleBefore>
                        Théoriques, procédurales...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(connaissance, i) in item.value.connaissances"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.connaissances, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="connaissance.value"
                    class="px-4"
                    libelle=""
                    name="connaissances"
                    @input="(newValue) => {connaissance.value = newValue}"
                  />
                </div>
                <add-button
                  class="mt-5"
                  libelle="Ajouter une connaissance"
                  @add="addItem('competences', item.value.connaissances)"
                />
              </div>
              <!-- FIN Connaissances associées -->

              <!-- DEBUT Comportements / aptitudes -->
              <div class="col-span-full md:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">
                    <info-bulle
                      :size-less="true"
                      libelle="Capacité de produire des actions et des réactions adaptées à l’environnement humain."
                      name="comportements_formation_pro"
                    >
                      <template #libelleBefore>
                        Comportements / aptitudes
                      </template>
                    </info-bulle>
                  </label>
                  <em class="block text-sm text-gray-600"><br></em> <!-- To align with others -->
                </div>

                <div
                  v-for="(comportement, i) in item.value.comportements"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.comportements, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="comportement.value"
                    class="px-4"
                    libelle=""
                    name="comportements"
                    @input="(newValue) => {comportement.value = newValue}"
                  />
                </div>
                <add-button
                  class="mt-5"
                  libelle="Ajouter une aptitude"
                  @add="addItem('competences', item.value.comportements)"
                />
              </div>
              <!-- FIN Comportements / aptitudes -->

              <delete-button 
                class="col-span-full"
                libelle="Supprimer ce parcours"
                @del="deleteItem(form.parcours, num)"
              />
            </div>
          </div>
          <!-- END Form Formation professionnelle continue -->

          <!-- BEGIN Form Stage -->
          <div
            v-show="parcoursDisplayed === num"
            :key="'stage'+num"
          >
            <div
              v-if="item.type === 'Stage' && !item.projet"
              class="bg-white grid grid-cols-12 gap-x-4 gap-y-10"
            >
              <date-picker
                :necessary-date="true"
                :value="item.value.debut_parcours"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Début"
                name="debut_parcours"
                @input="(newValue) => {if ($verifyDates({debut: newValue, fin: item.value.fin_parcours})){item.value.debut_parcours = newValue} else {badDates()} sortParcours();}"
              />

              <date-picker
                :necessary-date="true"
                :value="item.value.fin_parcours"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Fin"
                name="fin_parcours"
                @input="(newValue) => {if ($verifyDates({debut: item.value.debut_parcours, fin: newValue})){item.value.fin_parcours = newValue} else {badDates()}}"
              />

              <input-text
                :necessary="true"
                :value="item.value.duree_stage"
                class="md:col-span-3"
                libelle="Durée du stage (en h)"
                name="duree_stage"
                @input="(newValue) => {item.value.duree_stage = newValue}"
              />

              <input-text
                :error="true"
                :maxlength="50"
                :necessary="true"
                :value="item.value.intitule_parcours"
                class="md:col-span-6 col-start-1"
                libelle="Intitulé du stage"
                name="intitule_parcours"
                @input="(newValue) => {item.value.intitule_parcours = newValue}"
              />

              <input-text
                :necessary="true"
                :value="item.value.structure_accueil_parcours"
                class="md:col-span-3"
                libelle="Nom de la structure d'accueil"
                name="structure_accueil_parcours"
                @input="(newValue) => {item.value.structure_accueil_parcours = newValue}"
              />

              <input-text
                :necessary="true"
                :value="item.value.localisation_parcours"
                class="md:col-span-3"
                libelle="Localisation"
                name="localisation_parcours"
                @input="(newValue) => {item.value.localisation_parcours = newValue}"
              />

              <div class="col-span-full grid grid-cols-5 gap-x-4 gap-y-10">
                <input-select
                  :datas="[
                    {value: 'Interne'},
                    {value: 'Externe'},
                  ]"
                  :necessary="true"
                  :value="item.value.type_stage"
                  class="md:col-span-1"
                  label-libelle="<div><b>Interne</b> : Période d’apprentissage, de formation ou de perfectionnement dans une entreprise, un service ou une association en vue d'exercer une activité professionnelle ou autre. <div><b>Externe</b> : Période d’apprentissage, de formation ou de perfectionnement effectuée hors de son entreprise, son association ou son établissement d’origine."
                  libelle="Type de stage"
                  name="type_stage"
                  @input="(newValue) => {item.value.type_stage = newValue}"
                />

                <input-select
                  :datas="[
                    {value: 'Ordinaire'},
                    {value: 'Protégé'},
                  ]"
                  :necessary="true"
                  :value="item.value.milieu_stage"
                  class="md:col-span-1"
                  label-libelle="<div><b>Ordinaire</b> : Stage effectué dans une entreprise autre qu'un établissement spécialisé. Le milieu ordinaire de travail regroupe les employeurs publics et privés du marché du travail « classique ». <div><b>Protégé</b> : Stage effectué dans un environnement à caractère professionnel où le travail de la personne en situation de handicap est pleinement pris en compte aussi bien sur le plan professionnel que socio-médical et éducatif, et ce en vue de favoriser son épanouissement personnel et social."
                  libelle="Stage en milieu"
                  name="milieu_stage"
                  @input="(newValue) => {item.value.milieu_stage = newValue}"
                />

                <input-select
                  :datas="[
                    {value: 'Observation'},
                    {value: 'Application'},
                  ]"
                  :necessary="true"
                  :value="item.value.caracteristiques_stage"
                  class="md:col-span-1"
                  label-libelle="<div><b>Observation</b> : Il permet à un débutant de s’ouvrir au monde professionnel en découvrant un type d’organisation (entreprise, association, administration...), son mode de fonctionnement et son activité, ainsi que les rapports professionnels entre les personnes et un métier et/ou une fonction. <div><b>Application</b> : Il vise à mettre en pratique ses connaissances et à développer des compétences en milieu professionnel avec plus ou moins de responsabilités et d’autonomie selon le niveau du diplôme préparé."
                  libelle="Caractéristiques du stage"
                  name="caracteristiques_stage"
                  @input="(newValue) => {item.value.caracteristiques_stage = newValue}"
                />

                <input-select
                  :datas="[
                    {value: 'Oui'},
                    {value: 'Non'},
                  ]"
                  :necessary="true"
                  :value="item.value.attestation_stage"
                  class="md:col-span-1"
                  libelle="Attestation de stage"
                  name="attestation_stage"
                  @input="(newValue) => {item.value.attestation_stage = newValue}"
                />

                <input-select
                  :datas="[
                    {value: 'En cours'},
                    {value: 'Mené à son terme'},
                    {value: 'Interrompu'},
                  ]"
                  :necessary="true"
                  :value="item.value.precision_stage"
                  class="md:col-span-1"
                  libelle="Précision"
                  name="precision_stage"
                  @input="(newValue) => {item.value.precision_stage = newValue}"
                />
                <input-select
                  :datas="[
                    {value: 'Oui'},
                    {value: 'Non'},
                  ]"
                  :necessary="true"
                  :value="item.value.tuteur_stage"
                  class="md:col-span-1"
                  libelle="Tuteur de stage"
                  name="tuteur_stage"
                  @input="(newValue) => {item.value.tuteur_stage = newValue}"
                />

                <input-text
                  v-if="item.value.tuteur_stage === 'Oui'"
                  :necessary="true"
                  :value="item.value.nom_tuteur_stage"
                  class="md:col-span-1"
                  libelle="Nom / Prénom"
                  name="nom_tuteur_stage"
                  @input="(newValue) => {item.value.nom_tuteur_stage = newValue}"
                />

                <input-text
                  v-if="item.value.tuteur_stage === 'Oui'"
                  :necessary="true"
                  :value="item.value.fonction_tuteur_stage"
                  class="md:col-span-1"
                  libelle="Fonction"
                  name="fonction_tuteur_stage"
                  @input="(newValue) => {item.value.fonction_tuteur_stage = newValue}"
                />
              </div>

              <input-text-area
                :necessary="true"
                :value="item.value.aborde_parcours"
                class="lg:col-start-1 md:col-span-6"
                libelle="Les activités et tâches principales qui vous ont été confiées"
                name="aborde_parcours"
                @input="(newValue) => {item.value.aborde_parcours = newValue}"
              />
              <input-text-area
                :value="item.value.commentaires_parcours"
                class="md:col-span-6"
                libelle="Commentaires"
                name="commentaires_parcours"
                @input="(newValue) => {item.value.commentaires_parcours = newValue}"
              />


              <h4 class="col-span-full text-gray-600 my-10">
                Les compétences mobilisées pour mener à bien vos activités ou tâches professionnelles
              </h4>


              <div class="col-span-full xxl:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">Pratiques
                    professionnelles</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche."
                      name="pratiques_stage"
                    >
                      <template #libelleBefore>
                        être capable de...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(pratique, i) in item.value.pratiques"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.pratiques, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="pratique.value"
                    class="px-4"
                    libelle=""
                    name="pratiques"
                    @input="(newValue) => {pratique.value = newValue}"
                  />
                </div>

                <add-button
                  class="mt-5"
                  libelle="Ajouter une pratique"
                  @add="addItem('competences', item.value.pratiques)"
                />
              </div>

              <div class="col-span-full xxl:col-span-4">
                <div class="block ">
                  <label class="text-sm text-gray-900 font-medium">Connaissances associées</label>
                  <em class="block text-base text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience."
                      name="connaissances_stage"
                    >
                      <template #libelleBefore>
                        Théoriques, procédurales...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(connaissance, i) in item.value.connaissances"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.connaissances, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="connaissance.value"
                    class="px-4"
                    libelle=""
                    name="connaissances"
                    @input="(newValue) => {connaissance.value = newValue}"
                  />
                </div>
                <add-button
                  class="mt-5"
                  libelle="Ajouter une connaissance"
                  @add="addItem('competences', item.value.connaissances)"
                />
              </div>

              <div class="col-span-full xxl:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">
                    <info-bulle
                      :size-less="true"
                      libelle="Capacité de produire des actions et des réactions adaptées à l’environnement humain."
                      name="comportements_stage"
                    >
                      <template #libelleBefore>
                        Comportements / aptitudes
                      </template>
                    </info-bulle>
                  </label>
                  <em class="hidden lg:block text-sm text-gray-600"><br></em>
                  <!-- To align with others -->
                </div>

                <div
                  v-for="(comportement, i) in item.value.comportements"
                  :key="i"
                  class="flex content-center pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.comportements, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="comportement.value"
                    class="px-4"
                    libelle=""
                    name="comportements"
                    @input="(newValue) => {comportement.value = newValue}"
                  />
                </div>
                <add-button
                  class="mt-5"
                  libelle="Ajouter une aptitude"
                  @add="addItem('competences', item.value.comportements)"
                />
              </div>

              <!-- BEGIN button to delete a parcours -->
              <delete-button 
                class="col-span-full"
                libelle="Supprimer ce parcours"
                @del="deleteItem(form.parcours, num)"
              />
              <!-- END button to delete a parcours -->
            </div>
          </div>
          <!-- END Form Stage -->

          <!-- BEGIN Form Autre expérience -->
          <div
            v-show="parcoursDisplayed === num"
            :key="'autre_exp'+num"
          >
            <div
              v-if="item.type === 'Autre expérience'"
              class="bg-white grid grid-cols-12 gap-x-4 gap-y-10"
            >
              <input-text
                :error="true"
                :maxlength="50"
                :necessary="true"
                :value="item.value.intitule_parcours"
                class="col-start-1 md:col-span-6"
                libelle="Intitulé de l'expérience"
                name="intitule_parcours"
                @input="(newValue) => {item.value.intitule_parcours = newValue}"
              />

              <date-picker
                :necessary-date="true"
                :value="item.value.debut_parcours"
                class="col-span-full md:col-start-1 md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Début"
                name="debut_parcours"
                @input="(newValue) => {if (item.value.fin_parcours === '' || $verifyDates({debut: newValue, fin: item.value.fin_parcours})){item.value.debut_parcours = newValue} else {badDates()} sortParcours();}"
              />

              <date-picker
                :necessary-date="true"
                :value="item.value.fin_parcours"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Fin"
                name="fin_parcours"
                @input="(newValue) => {if (item.value.debut_parcours === '' || $verifyDates({debut: item.value.debut_parcours, fin: newValue})){item.value.fin_parcours = newValue} else {badDates()}}"
              />

              <input-text
                :necessary="true"
                :value="item.value.structure_accueil_parcours"
                class="col-start-1 md:col-span-3"
                libelle="Nom de la structure d'accueil"
                name="structure_accueil_parcours"
                @input="(newValue) => {item.value.structure_accueil_parcours = newValue}"
              />

              <input-text
                :necessary="true"
                :value="item.value.localisation_parcours"
                class="md:col-span-3"
                libelle="Localisation"
                name="localisation_parcours"
                @input="(newValue) => {item.value.localisation_parcours = newValue}"
              />
                            
              <input-text-area
                :necessary="true"
                :value="item.value.aborde_parcours"
                class="lg:col-start-1 md:col-span-6"
                libelle="Les activités abordées"
                name="aborde_parcours"
                @input="(newValue) => {item.value.aborde_parcours = newValue}"
              />

              <input-text-area
                :value="item.value.commentaires_parcours"
                class="md:col-span-6"
                libelle="Commentaires"
                name="commentaires_parcours"
                @input="(newValue) => {item.value.commentaires_parcours = newValue}"
              />

              <h4 class="col-span-full text-gray-600 my-10">
                Les compétences mobilisées
              </h4>

              <!-- DEBUT Pratiques professionnelles -->
              <div class="col-span-full md:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">Pratiques
                    professionnelles</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche."
                      name="pratiques_pro"
                    >
                      <template #libelleBefore>
                        être capable de...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(pratique, i) in item.value.pratiques"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.pratiques, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="pratique.value"
                    class="px-4"
                    libelle=""
                    name="pratiques"
                    @input="(newValue) => {pratique.value = newValue}"
                  />
                </div>

                <add-button
                  class="mt-5"
                  libelle="Ajouter une pratique"
                  @add="addItem('competences', item.value.pratiques)"
                />
              </div>
              <!-- FIN Pratiques professionnelles -->

              <!-- DEBUT Connaissances associées -->
              <div class="col-span-full md:col-span-4">
                <div class="block">
                  <label class="text-base text-gray-900 font-medium">Connaissances associées</label>
                  <em class="block text-sm text-gray-600">
                    <info-bulle
                      :is-libelle-input="true"
                      libelle="Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience."
                      name="connaissances_pro"
                    >
                      <template #libelleBefore>
                        Théoriques, procédurales...
                      </template>
                    </info-bulle>
                  </em>
                </div>

                <div
                  v-for="(connaissance, i) in item.value.connaissances"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.connaissances, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="connaissance.value"
                    class="px-4"
                    libelle=""
                    name="connaissances"
                    @input="(newValue) => {connaissance.value = newValue}"
                  />
                </div>
                <add-button
                  class="mt-5"
                  libelle="Ajouter une connaissance"
                  @add="addItem('competences', item.value.connaissances)"
                />
              </div>
              <!-- FIN Connaissances associées -->

              <!-- DEBUT Comportements / aptitudes -->
              <div class="col-span-full md:col-span-4">
                <div class="block ">
                  <label class="text-base text-gray-900 font-medium">
                    <info-bulle
                      :size-less="true"
                      libelle="Capacité de produire des actions et des réactions adaptées à l’environnement humain."
                      name="comportements_pro"
                    >
                      <template #libelleBefore>
                        Comportements / aptitudes
                      </template>
                    </info-bulle>
                  </label>
                  <em class="block text-sm text-gray-600"><br></em> <!-- To align with others -->
                </div>

                <div
                  v-for="(comportement, i) in item.value.comportements"
                  :key="i"
                  class="flex content-center lg:pr-10 pt-5"
                >
                  <delete-button
                    class="md:pt-2"
                    @del="deleteItem(item.value.comportements, i)"
                  />
                  <input-text
                    :necessary="true"
                    :value="comportement.value"
                    class="px-4"
                    libelle=""
                    name="comportements"
                    @input="(newValue) => {comportement.value = newValue}"
                  />
                </div>

                <add-button
                  class="mt-5"
                  libelle="Ajouter une aptitude"
                  @add="addItem('competences', item.value.comportements)"
                />
              </div>
              <!-- FIN Comportements / aptitudes -->

              <delete-button 
                class="col-span-full"
                libelle="Supprimer ce parcours"
                @del="deleteItem(form.parcours, num)"
              />
            </div>
          </div>
          <!-- END Form Autre expérience -->


          <!-- BEGIN Form Project Stage -->
          <div
            v-show="parcoursDisplayed === num"
            :key="'stageproj' + num"
            :id="`periode${num}`"
          >
            <div
              v-if="item.type === 'Stage' && item.projet"
              class="bg-white px-5 pt-5 md:px-15 md:pt-15 grid grid-cols-12 gap-x-4 gap-y-10"
            >
              <input-text
                class="md:col-span-3"
                name="intitule_periode"
                :necessary="true"
                libelle="Intitulé du stage"
                :value="item.intitule_periode"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="nom_structure"
                :necessary="true"
                libelle="Nom de la structure d'accueil"
                :value="item.nom_structure"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="localisation_stage"
                :necessary="true"
                libelle="Localisation"
                :value="item.localisation_stage"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="referent_stage"
                :necessary="true"
                libelle="Référent / interlocuteur principal"
                :value="item.referent_stage"
                disabled
              />
              <date-picker
                name="debut_periode"
                :necessary-date="true"
                libelle="Date de début du stage"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                :value="item.debut_periode"
                :disabled="true"
              />
              <date-picker
                name="fin_periode"
                :necessary-date="true"
                libelle="Date de fin du stage"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                :value="item.fin_periode"
                :disabled="true"
              />
              <input-text
                class="md:col-span-3"
                name="duree_stage"
                :necessary="true"
                libelle="Durée (en h)"
                :value="item.duree_stage"
                disabled
              />
              <input-text
                name="type_stage"
                :necessary="true"
                libelle="Type de stage"
                size="3"
                :value="item.type_stage"
                disabled
                class="md:col-span-3"
              />
              <input-text
                name="milieu_stage"
                :necessary="true"
                libelle="Stage en milieu"
                size="3"
                :value="item.milieu_stage"
                disabled
                class="md:col-span-3"
              />
              <input-text
                name="caracteristique_stage"
                :necessary="true"
                libelle="Caracteristiques du stage"
                size="3"
                :value="item.caracteristique_stage"
                disabled
                class="md:col-span-3"
              />
              <input-text
                name="etat_decision"
                :necessary="true"
                libelle="Etat de la décision"
                size="3"
                :value="item.etat_decision"
                disabled
                class="md:col-span-3"
              />
              <input-text-area
                name="objectifs_resultats"
                :necessary="true"
                libelle="Objectifs / Résultats attendus"
                size="4"
                :value="item.objectifs_resultats"
                class="lg:col-start-1 md:col-span-6"
                disabled
              />
              <input-text-area
                name="commentaire_stage"
                libelle="Commentaires"
                size="4"
                :value="item.commentaire_stage"
                class="md:col-span-6"
                disabled
              />
            </div>
          </div>
          <!-- END Project stage -->

          <!-- BEGIN Project formation -->
          <div
            v-show="parcoursDisplayed === num"
            :key="'formation' + num"
          >
            <div
              v-if="item.type === 'Formation' && item.projet"
              class="bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
            >
              <input-text
                class="md:col-span-3"
                name="intitule_periode"
                :necessary="true"
                libelle="Intitulé de la formation"
                :value="item.intitule_periode"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="organisme_formation"
                :necessary="true"
                libelle="Organisme de formation"
                :value="item.organisme_formation"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="localisation_formation"
                :necessary="true"
                libelle="Localisation"
                :value="item.localisation_formation"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="referent_formation"
                :necessary="true"
                libelle="Référent / Interlocuteur principal"
                :value="item.referent_formation"
                disabled
              />
              <date-picker
                name="debut_periode"
                :necessary-date="true"
                libelle="Date de début de formation"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                :value="item.debut_periode"
                :disabled="true"
              />
              <date-picker
                name="fin_periode"
                :necessary-date="true"
                libelle="Date de fin de formation"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                :value="item.fin_periode"
                :disabled="true"
              />
              <input-text
                class="md:col-span-3"
                name="duree_formation"
                :necessary="true"
                libelle="durée (en h)"
                :value="item.duree_formation"
                disabled
              />
              <input-text
                name="type_formation"
                :necessary="true"
                libelle="Type de formation"
                :value="item.type_formation"
                disabled
                class="md:col-span-3"
              />
              <input-text
                name="modalites_formation"
                :necessary="true"
                libelle="Modalités"
                :value="item.modalites_formation"
                disabled
                class="md:col-span-3"
              />

              <input-text
                name="dispositifs_formation"
                :necessary="true"
                libelle="Dispositifs retenus"
                :value="item.dispositifs_formation"
                disabled
                class="md:col-span-3"
              />
              <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
              >
                <input-text
                  v-if="item.dispositifs_formation === 'Autres'"
                  class="md:col-span-3"
                  name="dispositifs_formation_precis"
                  :necessary="true"
                  libelle="Précisez (si autre)"
                  :value="item.dispositifs_formation_precis"
                  disabled
                />
              </transition>

              <input-text
                name="formation_suivie"
                :necessary="true"
                libelle="Formation suivie au titre de"
                :value="item.formation_suivie"
                disabled
                class="md:col-span-3"
              />
              <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
              >
                <input-text
                  v-if="item.formation_suivie === 'Autre'"
                  class="md:col-span-3"
                  :necessary="true"
                  name="dispositifs_formation_precis"
                  libelle="Précisez (si autre)"
                  :value="item.formation_suivie_precis"
                  disabled
                />
              </transition>

              <input-text
                name="etat_decision"
                :necessary="true"
                libelle="Etat de la décision"
                :value="item.etat_decision"
                disabled
                class="md:col-span-3"
              />
              <input-text-area
                name="objectifs_formation"
                :necessary="true"
                libelle="Objectifs pédagogiques"
                size="4"
                :value="item.objectifs_formation"
                disabled
                class="lg:col-start-1 md:col-span-6"
              />
              <input-text-area
                name="commentaire_formation"
                libelle="Commentaires"
                size="4"
                :value="item.commentaire_formation"
                class="md:col-span-6"
                disabled
              />
            </div>
          </div>
          <!--END Project formation -->

          <!--END Project formation -->
          <!-- BEGIN  Accompagnement -->
          <div
            v-show="parcoursDisplayed === num"
            :key="'accompagnement' + num"
          >
            <div
              v-if="item.type === 'Accompagnement' && item.projet"
              class="bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
            >
              <input-text
                class="md:col-span-3"
                name="intitule_periode"
                :necessary="true"
                libelle="Intitulé"
                :value="item.intitule_periode"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="organisme_accompagnement"
                :necessary="true"
                libelle="Organisme"
                :value="item.organisme_accompagnement"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="localisation_accompagnement"
                :necessary="true"
                libelle="Localisation"
                :value="item.localisation_accompagnement"
                disabled
              />
              <input-text
                class="md:col-span-3"
                name="referent_accompagnement"
                :necessary="true"
                libelle="Référent / Interlocuteur principal"
                :value="item.referent_accompagnement"
                disabled
              />
              <date-picker
                name="debut_periode"
                :necessary-date="true"
                libelle="Date de début de l'accompagnement"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                :value="item.debut_periode"
                :disabled="true"
              />
              <date-picker
                name="fin_periode"
                :necessary-date="true"
                libelle="Date de fin de l'accompagnement"
                class="col-span-full md:col-span-3"
                format="dd/MM/yyyy"
                initialview="year"
                :value="item.fin_periode"
                :disabled="true"
              />
              <input-text
                class="md:col-span-3"
                name="duree_accompagnement"
                :necessary="true"
                libelle="durée (en h)"
                :value="item.duree_accompagnement"
                disabled
              />
              <input-text
                name="type_accompagnement"
                :necessary="true"
                libelle="Type d'accompagnement"
                :value="item.type_accompagnement"
                disabled
                class="md:col-span-3"
              />
              <input-text
                name="modalites_accompagnement"
                :necessary="true"
                libelle="Modalités"
                :value="item.modalites_accompagnement"
                disabled
                class="md:col-span-3"
              />

              <input-text
                name="dispositifs_accompagnement"
                :necessary="true"
                libelle="Dispositifs retenus"
                :value="item.dispositifs_accompagnement"
                disabled
                class="md:col-span-3"
              />
              <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
              >
                <input-text
                  v-if="item.dispositifs_accompagnement === 'Autres'"
                  class="md:col-span-3"
                  name="dispositifs_accompagnement_precis"
                  :necessary="true"
                  libelle="Précisez (si autre)"
                  :value="item.dispositifs_accompagnement_precis"
                  disabled
                />
              </transition>

              <input-text
                name="etat_decision"
                :necessary="true"
                libelle="Etat de la décision"
                :value="item.etat_decision"
                disabled
                class="md:col-span-3"
              />
              <input-text-area
                name="objectifs_accompagnement"
                :necessary="true"
                libelle="Objectifs pédagogiques"
                size="4"
                :value="item.objectifs_accompagnement"
                disabled
                class="lg:col-start-1 md:col-span-6"
              />
              <input-text-area
                name="commentaire_accompagnement"
                libelle="Commentaires"
                size="4"
                :value="item.commentaire_accompagnement"
                disabled
                class="md:col-span-6"
              />
            </div>
          </div>
          <!--END Project formation -->
          <!--END  Accompagnement -->
        </template>
      </list-grid>
      <!-- END list of parcours -->
    </div>
    <!-- END Situation professionnelle -->
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import AddButton from '../../../components/Inputs/AddButton';
import DeleteButton from '../../../components/Inputs/DeleteButton';

import ListGrid from '../../../components/AccordionTable/ListGrid.vue';

import Icon from '../../../components/Icon';
import InfoBulle from '../../../components/InfoBulle';
import VerifyDates from '../../../mixins/VerifyDates';
import Tag from '../../../components/Tag.vue';

import ClickOutside from 'vue-click-outside';
import axios from 'axios';
import InfoBulleHover from '../../../components/InfoBulleHover.vue';

export default {
  components: {
    InfoBulleHover,
    InputText,
    InputTextArea,
    InputSelect,
    DatePicker,
    Icon,
    InfoBulle,
    AddButton,
    DeleteButton,
    Tag,
    ListGrid
  },

  props: ['progressbar'],

  name: 'Parcours',
  mixins: [VerifyDates],

  data() {
    return {
      // Initial state of the form
      form: {
        parcours: [],
      },

      otherParcours: [],

      typeParcours: [
        'Formation initiale',
        'Parcours professionnel',
        'Formation professionnelle continue',
        'Stage',
        'Autre expérience',
      ],

      dropDownMenu: false,
      parcoursDisplayed: -1,

      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
    };
  },
    
  async mounted() {
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)

    await this.fetchOtherParcours();
    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is no change in form
  },

  methods: {
    ...mapMutations({
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
    }),

    typeTheme(type) {
      if (type === 'Formation initiale' || type === 'Formation') {
        return 'pink';
      } else if (type === 'Formation professionnelle continue') {
        return 'indigo';
      } else if (type === 'Parcours professionnel' || type === 'Accompagnement') {
        return 'orange';
      } else if (type === 'Stage') {
        return 'teal';
      } else {
        return 'white';
      }
    },

    async fetchOtherParcours() {
      try {
        let { data: parcours} = await axios.get(`/api/parcours/${this.infosPass.id_pass}`);
        this.otherParcours = parcours.map((other) => {

          const otherParcours = {
            intitule_parcours: other.intitule_periode,
            debut_parcours: other.debut_periode,
            fin_parcours: other.fin_periode,
            ...other
          };

          return {
            projet: other.projet,
            type: other.type,
            value: otherParcours,
            ...other,
          };
        });
      }catch (error) {
        console.error(error);
      }
    },

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);

      //sort parcours list
      this.sortParcours(false);
    },
    async addItem(type, el) {
      if (type === 'parcours') {
        const emptyContent = {};

        emptyContent.pratiques = [];
        emptyContent.connaissances = [];
        emptyContent.comportements = [];
        emptyContent.debut_parcours = '';
        emptyContent.fin_parcours = '';
        emptyContent.intitule_parcours = '';

        if (el === 'Stage') {
          emptyContent.tuteur_stage = '';
        }

        if(el === 'Formation professionnelle continue'){
          emptyContent.raisons_formation_pro = '';
          emptyContent.certifications_obtenues_formation_pro = '';
        }

        await this.form.parcours.unshift({type: el, value: emptyContent});

        this.dropDownMenu = false;
        await this.$refs.listParcours.displayNum(0, true);
      } else {
        el.push({});
      }
    },

    deleteItem(el, index) {
      const isParcoursEl = el.every(item => item.hasOwnProperty('type'));

      if (isParcoursEl) {
        let parcourToDelete = this.sortedParcours[index];

        this.form.parcours = this.form.parcours.filter((item) => JSON.stringify(item) !== JSON.stringify(parcourToDelete));
        this.sortParcours();
        this.$refs.listParcours.displayNum(-1);
        return;
      }

      el.splice(index, 1);
      this.sortParcours();
      this.$refs.listParcours.displayNum(-1);
    },

    displayDropdownMenu() {
      this.dropDownMenu = !this.dropDownMenu;
    },

    forceHide(e) {
      if (e.target.classList.contains('dropdown-menu')) {
        this.displayDropdownMenu();
      } else {
        if (this.dropDownMenu) {
          this.dropDownMenu = false;
        }
      }
    },

    sortParcours(sorting=true) {
      let parcoursDisplayed = this.form.parcours[this.parcoursDisplayed];
      this.form.parcours.sort(function (a, b) {
        let [endDateA, endDateB] = [new Date(a.value.fin_parcours), new Date(b.value.fin_parcours)];

        if (a.value.fin_parcours === null) {
          return -1;
        }
        if (b.value.fin_parcours === null) {
          return 1;
        }

        if (endDateA > endDateB) {
          return -1;
        }
        if (endDateA < endDateB) {
          return 1;
        }
        return 0;
      });
      if(sorting){
        this.$refs.listBilans.displayNum(this.form.parcours.indexOf(parcoursDisplayed), true);
      }
    }
  },

  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
    }),

    sortedParcours() {
      return this.form.parcours.concat(this.otherParcours)
        .sort((a, b) => {
          let [endDateA, endDateB] = [new Date(a.value.fin_parcours), new Date(b.value.fin_parcours)];
          if (a.value.fin_parcours === null) {
            return -1;
          }
          if (b.value.fin_parcours === null) {
            return 1;
          }
          if (endDateA > endDateB) {
            return -1;
          }
          if (endDateA < endDateB) {
            return 1;
          }
          return 0;
        });
    }
  },

  watch: {
    form: {
      handler() {

        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    }
  },

  directives: {
    ClickOutside
  }
};
</script>
